import { get } from 'utils/lodash'
import api from 'api'
import {
  CACHE_TAG_ACCOUNT_DETAILS,
  CACHE_TAG_ACCOUNT_DETAILS_BY_ID,
  CACHE_TAG_CREDIT_LIMIT_HISTORY,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
} from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAccountDetails: builder.query({
      query: ({ accountId, addRecent = false }) => ({
        url: `/api/v1/core/accounts/${accountId}`,
        method: 'GET',
        params: {
          'add-recent': addRecent,
        },
      }),
      providesTags: (result, error, { accountId }) => [CACHE_TAG_ACCOUNT_DETAILS, { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId }],
      transformResponse: res => ({
        ...get(res, 'account', {}),
        balanceDetails: get(res, 'accountForBalance', {}),
        cfCount: get(res, 'cfCountForLocations', []),
      }),
    }),
    updateCreditLimit: builder.mutation({
      query: ({ accountId, creditLimitCents }) => ({
        url: `/api/v1/core/accounts/${accountId}/credit-limit`,
        method: 'PATCH',
        body: {
          creditLimitCents,
        },
      }),
      invalidatesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_DETAILS,
        CACHE_TAG_CREDIT_LIMIT_HISTORY,
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
        { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
        { type: CACHE_TAG_CREDIT_LIMIT_HISTORY, id: accountId },
      ],
    }),
    getCreditLimitHistoryByAccount: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/credit-limit/history`,
        method: 'GET',
      }),
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_CREDIT_LIMIT_HISTORY,
        { type: CACHE_TAG_CREDIT_LIMIT_HISTORY, id: accountId },
      ],
    }),
  }),
})

export const { useLazyGetAccountDetailsQuery, useUpdateCreditLimitMutation, useLazyGetCreditLimitHistoryByAccountQuery } = extendedApi
